import { MicrositeTemplate } from '~/model';
import { type ComponentConfig } from '@puckeditor/core';
import HeroBlockAlpha from '~/editor/templates/alpha/HeroBlockAlpha';
import HeroBlockDelta from '~/editor/templates/delta/HeroBlockDelta';
import HeroBlockEpsilon from '~/editor/templates/epsilon/HeroBlockEpsilon';
import HeroBlockEta from '~/editor/templates/eta/HeroBlockEta';
import HeroBlockZeta from '~/editor/templates/zeta/HeroBlockZeta';
import { DEMO_PHOTOS } from '~/demo';
import HeroBlockBeta from '~/editor/templates/beta/HeroBlockBeta';

export interface HeroBlockProps {
	tagline?: string;
	address1?: string;
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_HERO: ComponentConfig<HeroBlockProps> = {
	label: 'Hero',
	fields: {
		tagline: {
			type: 'text',
		},
		address1: {
			type: 'text',
		},
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <HeroBlock {...props} />;
	},
};

export default function HeroBlock({ tagline, address1, template }: HeroBlockProps) {
	if (template === MicrositeTemplate.ALPHA) {
		return <HeroBlockAlpha image={DEMO_PHOTOS[0]} />;
	}
	if (template === MicrositeTemplate.BETA) {
		return <HeroBlockBeta />;
	}
	if (template === MicrositeTemplate.DELTA) {
		return <HeroBlockDelta address1={address1} address2={tagline} />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		return <HeroBlockEpsilon address1={address1} address2={tagline} />;
	}
	if (template === MicrositeTemplate.ZETA) {
		return <HeroBlockZeta address1={address1} />;
	}

	return <HeroBlockEta tagline={tagline} address2={address1} />;
}
